import { render, staticRenderFns } from "./EditAttendeeFormCpt.vue?vue&type=template&id=4056d7dc&scoped=true&"
import script from "./EditAttendeeFormCpt.vue?vue&type=script&lang=ts&"
export * from "./EditAttendeeFormCpt.vue?vue&type=script&lang=ts&"
import style0 from "./EditAttendeeFormCpt.vue?vue&type=style&index=0&id=4056d7dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4056d7dc",
  null
  
)

export default component.exports